import { QUIZ_PASS_REWARD } from '../../../../domain';
import { OPENED_DELIVERY_ITEM_BACKGROUND_URL } from '../../../assets/deliveryDialogAssets';
import iconTicketSvg from '../../components/atomic/dialog/ticket_reward/icon_ticket.svg';
import './QuizTicketPopup.css';

/** +1 ticket toast on the opened-delivery plaque after a correct quiz answer. */
export function QuizTicketPopup() {
  return (
    <div className="quiz-ticket-popup" aria-hidden>
      <img
        className="quiz-ticket-popup__plaque"
        src={OPENED_DELIVERY_ITEM_BACKGROUND_URL}
        alt=""
        draggable={false}
      />
      <span className="quiz-ticket-popup__plus">+{QUIZ_PASS_REWARD}</span>
      <img
        className="quiz-ticket-popup__icon"
        src={iconTicketSvg}
        alt=""
        draggable={false}
      />
    </div>
  );
}
